import { createAction, props } from '@ngrx/store';
import { AdminOrganizationConfig } from 'src/app/admin/models/organization.model';
import { AdminOrganizationConfigApiError } from './admin-organization-config.errors';

export const AdminLoadCurrentOrganizationConfig = createAction(
  '[Admin Organization Config] Load Current Organization Config',
  props<{ id: number }>(),
);

export const AdminSetCurrentOrganizationConfig = createAction(
  '[Admin Organization Config] Set Current Organization Config',
  props<{ config: AdminOrganizationConfig }>(),
);

export const AdminCreateOrganizationConfig = createAction(
  '[Admin Organization Config] Create Organization Config',
  props<{ organizationId: number; config: Partial<AdminOrganizationConfig> }>(),
);

export const AdminDeleteOrganizationConfig = createAction(
  '[Admin Organization Config] Delete Organization Config',
  props<{ id: number }>(),
);

export const AdminSetOrganizationConfigError = createAction(
  '[Admin Organization Config] Set Organization Config Error',
  props<{ error: AdminOrganizationConfigApiError }>(),
);

export const AdminRemoveOrganizationConfigError = createAction(
  '[Admin Organization Config] Remove Organization Config Error',
);
